<mat-card appearance="outlined" class="audio-player-container mat-elevation-z4">
  <mat-card-header>


    @if (!isLoggedIn() || !ownsVideo()) {
      <div class="access-msg" >
        <mat-card-title class="main-title">Members Audio Library</mat-card-title>
        <mat-card-subtitle>Memorization Audio Files</mat-card-subtitle>
        <div class="access-warning">
          Accessible with purchase of a video
        </div>
      </div>
    }


  </mat-card-header>

  <mat-card-content class="audio-content-area" >

    <!-- Audio Player Section -->
    <div class="audio-player-section mat-elevation-z2">
      <h5 class="section-heading">{{ selectedAudio ? selectedAudio.title : 'None Selected' }}</h5>

      <div class="audio-playback-area">
        <!-- The HTML5 audio element - hidden from view, controlled by custom buttons -->
        <audio #audioElement [src]="selectedAudio?.audioUrl" controls="false" controlsList="nodownload"></audio>

        <div class="player-controls-display">
          <div class="timeline">
            <mat-slider
              class="audio-slider"
              min="0"
              [max]="duration"

              [displayWith]="formatTime"
            #ngSlider><input matSliderThumb [value]="currentTime" (input)="audioElementRef.nativeElement.currentTime = {source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value" #ngSliderThumb="matSliderThumb" /></mat-slider>
            <div class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</div>
          </div>

          <div class="player-buttons">
            <button mat-icon-button (click)="rewind(10)" [disabled]="!selectedAudio" matTooltip="Rewind 10s">
              <mat-icon>replay_10</mat-icon>
            </button>
            <button mat-fab color="primary" (click)="togglePlayPause()" [disabled]="!selectedAudio" matTooltip="{{ isPlaying ? 'Pause' : 'Play' }}">
              <mat-icon class="playButtonIcon">{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="fastForward(10)" [disabled]="!selectedAudio" matTooltip="Fast Forward 10s">
              <mat-icon>forward_10</mat-icon>
            </button>

            <!-- <button  mat-icon-button
            (click)="cyclePlaybackSpeed()"
            [disabled]="!selectedAudio"
            matTooltip="Playback Speed: {{ currentPlaybackSpeedDisplay }}"
            >
            <mat-icon>speed</mat-icon> <span class="speed-indicator">{{ currentPlaybackSpeedDisplay }}</span>
          </button> -->

        </div>

      </div>
    </div>
  </div>

  <!-- Audio List Section -->
  <div class="audio-list-section">
    <h4 class="section-heading">Topics</h4>
    <mat-nav-list class="audio-list">
      @for (audio of audioFiles; track audio) {
        <mat-list-item class="audio-list-item" (click)="onSelectAudio(audio)"
          [class.selected-item]="selectedAudio && selectedAudio.id === audio.id">
          <div class="list-text" matLine><span class="list-icon" aria-hidden="true">🎙️</span>{{ audio.title }}</div>
        </mat-list-item>
      }
    </mat-nav-list>
  </div>


</mat-card-content>
</mat-card>
